/**
* 日期处理函数
*/
/*eslint-disable */
import moment from 'moment'
import tools from 'common/javascript/tools/tools'
const dateTooles = {

  formatTime(time, option) {
    time = + time * 1000
    const d = new Date(time)
    const now = Date.now()
  
    const diff = (now - time) / 1000
    if (diff < 59) {
      return Math.ceil(diff) + '秒前'
    } else if (diff < 3600) {
      // less 1 hour
      return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + '小时前'
    }
    if (option) {
      return parseTime(time, option)
    } else {
      return d.getFullYear() + '.' + (d.getMonth() + 1) + '.' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    }
  },

  dateFormater (value, format) {
    if (tools.isString(value)) {
      value = parseInt(value)
    }
    let date = new Date(value)
    // 单参数处理
    if (arguments.length === 1) {
      date = new Date()
      format = value
    }

    if (!format) {
      format = 'YYYY-MM-DD'
    }
    return moment(date).format(format)
  },
  createDate (value) { // 创建日期
    if (tools.isString(value)) {
      value = parseInt(value)
    }
    let date = new Date(value)
    return date
  },
  stringToDate (timeStr, formatStr) { // 字符串转日期时间戳
    if (!formatStr) {
      formatStr = 'YYYY-MM-DD HH:mm:ss'
    }
    const date = moment(timeStr, formatStr)
    if (!date.isValid()) {
      return null
    } else {
      return date.valueOf()
    }
  },
  getDateObject (timeStr, formatStr) { // 字符串转日期
    if (!formatStr) {
      formatStr = 'YYYY-MM-DD HH:mm:ss'
    }
    const date = moment(timeStr, formatStr)
    if (!date.isValid()) {
      return null
    } else {
      return date
    }
  },
  // 日期（2014-08-12 09:25:24）转时间戳（毫秒级）
  dateTotimestamp (date) {
    var str = date.trim().replace(/\./g, ':').replace(' ', ':')
    var arr = str.split(':')
    return Date.parse(new Date(arr[0], (arr[1] - 1), arr[2], arr[3], arr[4], arr[5]))
  },
  // 获取当前时间起，未来几个月的时间戳 @param: futureMonth 计算的月数
  monthTotimestamp (futureMonth) {
    futureMonth = futureMonth || 0
    return moment().add(futureMonth, 'months').valueOf()
  },
  timeSince(timestamp) {
    // if (timestamp == undefined || timestamp == null) {
    //   return 'N/A'
    // }
    //   var date = new Date(timestamp / 1000);

    //   var seconds = Math.floor((new Date() - date) / 1000);
  
    //   var interval = seconds / 31536000;
    //   if (interval > 1) {
    //       return "(" + Math.floor(interval) + " years ago)";
    //   }
    //   interval = seconds / 2592000;
    //   if (interval > 1) {
    //       return "(" + Math.floor(interval) + " months ago)";
    //   }
    //   interval = seconds / 86400;
    //   if (interval > 1) {
    //       return "(" + Math.floor(interval) + " days ago)";
    //   }
    //   interval = seconds / 3600;
    //   if (interval > 1) {
    //       return "(" + Math.floor(interval) + " hours ago)";
    //   }
    //   interval = seconds / 60;
    //   if (interval > 1) {
    //       return "(" + Math.floor(interval) + " minutes ago)";
    //   }
    //   return "(" + Math.floor(seconds) + " seconds ago)";
    if (timestamp == undefined || timestamp == null) {
      return 'N/A';
    }
  
    // Determine if the timestamp is in microseconds or milliseconds
    var isMicroseconds = timestamp.toString().length > 13;
    var date = new Date(isMicroseconds ? timestamp / 1000 : timestamp);
  
    var seconds = Math.floor((new Date() - date) / 1000);
  
    if (seconds < 0) {
      return 'In the future';
    }
  
    var interval = seconds / 31536000;
    if (interval > 1) {
      return `(${Math.floor(interval)} years ago)`;
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return `(${Math.floor(interval)} months ago)`;
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return `(${Math.floor(interval)} days ago)`;
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return `(${Math.floor(interval)} hours ago)`;
    }
    interval = seconds / 60;
    if (interval > 1) {
      return `(${Math.floor(interval)} minutes ago)`;
    }
    return `(${Math.floor(seconds)} seconds ago)`;
  }
}
export default dateTooles
